import React from 'react';
import Editor from '../../Editor';
import { EditorProps } from '../../types';
import cn from 'classnames';
import { extConfig } from './config';
import GroupAboutBubbleMenu from '../../../menus/GroupAboutBubbleMenu';

import viewerStyles from '../../../Viewer/presets/UserAbout/UserAbout.scss';
import s from './GroupAbout.scss';

const GroupAboutEditor: React.FC<
  Omit<EditorProps, 'extensionConfig' | 'presetId'>
> = props => {
  return (
    <>
      <Editor
        {...props}
        withinModal
        presetId="groupabout"
        className={cn(s['root'], viewerStyles['root'])}
        extensionConfig={extConfig}
      >
        {(editor, scrollContainer) => (
          <GroupAboutBubbleMenu scrollContainerRef={scrollContainer} />
        )}
      </Editor>
    </>
  );
};
GroupAboutEditor.displayName = 'GroupAboutEditor';

export default GroupAboutEditor;
